import React from 'react';

import { VOID_FUNCTION } from 'constants/index';

import * as S from '../FinalModal/FinalModal.style';

export const FinalModal = ({ error = false, onClose = VOID_FUNCTION }) => {
  return (
    <S.StyledPopup onClose={onClose}>
      <S.Wrapper>
        <S.ImgWrapper>{!error ? <S.StyledOkImg /> : <S.StyledErrorCrossImg />}</S.ImgWrapper>
        <S.Title>{!error ? 'Документы подписаны' : 'Не удалось отправить код'}</S.Title>
        {error && <S.Description>Напишите в чат поддержки</S.Description>}
      </S.Wrapper>
    </S.StyledPopup>
  );
};
